import React from 'react';
import I18n from 'i18n-js';
import SiteFooter from './site_footer';
import SiteSubFooter from './site_subfooter';
import { useURL } from '@reverbdotcom/commons/src/url_context';
import { RCText } from '@reverbdotcom/cadence/components';
import { isListingExperienceURL } from '@reverbdotcom/commons/src/url_helpers';

export function SiteFooterContainer() {
  const url = useURL();

  if (isListingExperienceURL(url)) return <SimpleSiteFooter />;

  return (
    <>
      <SiteFooter />
      <SiteSubFooter />
    </>
  );
}

export function SimpleSiteFooter() {
  return (
    <div className="d-flex fx-justify-center fx-dir-row mobile-fx-dir-col align-center padding-10 gap-4 bdt-1 bd-primary">
      <span>
        <RCText.Utility size="400" color="rc-color-text-secondary">
          {I18n.t('discovery.siteSubFooter.copyright', { year: new Date().getFullYear() })}
        </RCText.Utility>
      </span>
      <span>
        <RCText.Utility size="400" color="rc-color-text-secondary">
          <a href="/page/terms" className="text-link">
            {I18n.t('discovery.siteSubFooter.terms')}
          </a>
        </RCText.Utility>
      </span>
      <span>
        <RCText.Utility size="400" color="rc-color-text-secondary">
          <a href="/page/privacy" className="text-link">
            {I18n.t('discovery.siteSubFooter.privacy')}
          </a>
        </RCText.Utility>
      </span>
    </div>
  );
}

export default SiteFooterContainer;
